import { EnergyType } from '@energy-retailer/constants';

import { Button } from '@/components/button';
import { getProductPlanEstimatedPrice } from '@/lib/utils/get-product-plan-estimated-price';

import { ProductPlanCardBanner } from './banner';
import { PlanDetailListings } from './plan-detail-listing';
import { cardVariants } from './style';
import { ProductPlanCardTitle } from './title';

import type { PlanSchema } from '@energy-retailer/schema';
import type { ComponentProps } from 'react';


type ProductPlanProps = {
  plan: PlanSchema;
  changePlan?: () => void;
} & Pick<ComponentProps<typeof PlanDetailListings>, 'priceFrequency'>;

const ProductPlanCardCart = ({
  plan,
  changePlan,
  priceFrequency,
}: ProductPlanProps) => {
  const price = getProductPlanEstimatedPrice({
    estimates: plan.estimates,
    priceFrequency,
  });

  return (
    <div className={cardVariants({ planType: plan.product.productType })}>
      <ProductPlanCardBanner />
      <div className="grid grid-cols-12 gap-a px-d pb-a pt-d md:px-b md:pt-b">
        <div className="col-span-12 flex flex-col gap-b">
          <ProductPlanCardTitle product={plan.product} />
          <PlanDetailListings
            itemType="cart"
            state={plan.state}
            price={price}
            comparison={
              plan.energyType === EnergyType.Electricity
                ? plan.comparison
                : undefined
            }
            solarFeedTariff={
              plan.energyType === EnergyType.Electricity
                ? plan.feedInRates?.default
                : undefined
            }
            superOffPeakTariff={plan.rates.superOffPeak}
            vdoTooltip={plan.offerTooltip}
            hasAddress
          />
        </div>
        {changePlan ? (
          <div className="col-span-12 flex items-center justify-center">
            <Button
              variant="tertiary"
              onClick={changePlan}
            >
              Change Plan
            </Button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export { ProductPlanCardCart };
